module.exports = new __parcel__URL__("jest.effba53e.svg").toString();